
function previewlink(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const src = urlParams.get('src');
  if(src == 'preview'){
    $('.nav-sale-badge.schuhe').show();
    //$('.lp-sale-badge.tweed:not(.fliegen)').show().css('background-image', "url(//www.john-crocket.de/cdn/shop/t/83/assets/badge_sale-20_dr_250x.png?v=49255666782349365561739953374)");
    $('.lp-sale-badge.schuhe').show();
    //$('.hero-salebanner').show();
    $('.hover-button.sale.schuhe').show();
    $('.hover-button.sale.schuhe + img.hover-button').hide();
  }
}

// Öffnungszeiten Phone Indicator
var calltimeFrom = '10:30:00';
var calltimeTo = '18:30:00';
var calltimeFromShort = '10:00:00';
var calltimeToShort = '16:00:00';

var specialTimes = {
  
  // Veilchendienstag
  "2020-2-25": {
		"from": "08:00:00",
		"to": "16:00:00"
	},
  // Karfreitag
	"2020-4-10": {},
  // Ostermontag
	"2020-4-13": {},
  // Tag der Arbeit
	"2020-5-1": {},
  // Christi Himmelfahrt
	"2020-5-21": {},
  // Pfingstmontag
	"2020-6-1": {},
  // Fronleichnam
	"2020-6-11": {},
  // Tag der Deutschen Einheit
	"2020-10-3": {},
  // Weihnachten
	"2020-12-24": {},
    "2020-12-25": {},
    "2020-12-26": {},
  // Silvester
	"2020-12-31": {},
  // Neujahr
	"2021-1-1": {},
  //Karnevalsbeginn
    "2024-11-11": {}
}

function checkCallTime() {

	var currentTime = new Date();
	var month = currentTime.getMonth() + 1;
	var day = currentTime.getDate();
	var year = currentTime.getFullYear();
	var dayofweek = currentTime.getDay();

  var dayStr = year + "-" + month + "-" + day;

  tmpFrom = getTimestamp(dayStr + ' '+ calltimeFrom);
  tmpTo = getTimestamp(dayStr + ' '+ calltimeTo);

  if (specialTimes[dayStr] !== undefined) {
    tmpFrom = getTimestamp(dayStr + ' '+ (specialTimes[dayStr].from || '23:59:59'));
    tmpTo = getTimestamp(dayStr + ' '+ (specialTimes[dayStr].to || '00:00:00'));
  } else if (dayofweek == 6) {
    tmpFrom = getTimestamp(dayStr + ' '+ calltimeFromShort);
	tmpTo = getTimestamp(dayStr + ' '+calltimeToShort);
  }

	if (dayofweek>0 && dayofweek<6) {
    // console.log("currentTime: ", currentTime);
    // console.log("tmpFrom: ", tmpFrom);
    // console.log("tmpTo: ", tmpTo);
    // console.log("bool: ", currentTime >= tmpFrom && currentTime <= tmpTo);
		if (currentTime >= tmpFrom && currentTime <= tmpTo){
      // console.debug("Innerhalb der Öffnungszeiten");
      jQuery('.phone-indicator').removeClass("red");
    } else {
      // console.debug("Außerhalb der Öffnungszeiten");
      jQuery('.phone-indicator').addClass("red");
    }
	} else {
    // console.debug("Sonntag");
    jQuery('.phone-indicator').addClass("red");
  }
}

function getTimestamp(str) {
  var d = str.match(/\d+/g);
  return +new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);
}

function phonetimesText() {
  //Hier den gewünschten Text eingeben der bei Hover über die Telefonanzeige angezeigt wird
  //wird global (header, footer, store-seite) geändert
  var l = $('html').attr('lang');
  var newtext = "Sie erreichen uns Montag bis Freitag von 10:30 bis 18:30 Uhr, Samstag von 10:00 bis 16:00. Sonn- und Feiertags haben wir geschlossen.";
  if(l == "en"){
    newtext = "You can reach us Monday through Friday from 10.30 am to 6:30 pm, Saturday from 10 am to 4 pm. On sundays and holidays we are closed."
  }
  jQuery('.phonetimes').html(newtext);
}
//ende Öffnungszeiten Indikator

function langDetection(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const src = urlParams.get('src');
  
  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }
  function eraseCookie(name) {   
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  var x = getCookie("languagechoice");
  
  var userLang = navigator.languages || navigator.userLanguages;
  var l = $('html').attr('lang'),
      prefDE = false;
  for (var i = 0; i < userLang.length; i++) {
    var str = userLang[i].toLowerCase();
    if(str.includes("de")){ 
      prefDE = true;
      break;
    }                 
  }
  if(prefDE && l == "en" && x != "en"){
    //var banner = "<div class='langoverlay'><div class='langbanner'><p>Sie sind auf der englischen Seite unseres Shops gelandet. Falls Sie lieber in den deutschsprachigen Shop wechseln möchten, klicken Sie bitte hier:</p><button class='change'>Zum deutschsprachigen Shop</button><button class='stay'>Nicht wechseln und schließen</button></div></div>";
    //var style = "<style>.langoverlay{display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.5);z-index:100}.langbanner{width:34%;background:#fff;top:50%;position:absolute;left:50%;transform:translate(-50%,-50%);padding:50px 30px;text-align:center;border-radius:5px;box-shadow:0 0 15px #62626262}.langbanner p{text-align:center}.langbanner button{font-size:22px;font-weight:inherit;width:100%;padding:5px 20px;border-radius:3px}.langbanner button.change{color:#fff;background:#4ba733;margin-bottom: 1rem;margin-top: 1rem}</style>";
    var banner = "<div class='langoverlay'><div class='langbanner'><button class='change de'>Weiter auf Deutsch</button><button class='stay en'>Continue in English</button></div></div>";
    var style = "<style>.langoverlay{display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.5);z-index:100}.langbanner{width:34%;min-width: 450px;background:#fff;top:50%;position:absolute;left:50%;transform:translate(-50%,-50%);padding:70px 50px;text-align:center;border-radius:5px;box-shadow:0 0 15px #62626262}.langbanner button{font-size:22px;font-weight:inherit;width:100%;padding:5px 20px;border-radius:3px;color: #fff;background: #a1a1a1;position: relative}.langbanner button.change{background:#4ba733;margin-bottom: 1rem}.langbanner button:before{content:'';width: 46px; height: 30px;position:absolute;left:7px;top: 7px;background-size: contain; background-repeat:no-repeat; background-image: url(https://cdn.shopify.com/s/files/1/0317/5176/6151/files/gb-flag.jpg?v=1650961579)}.langbanner button.de:before {background-image:url(https://cdn.shopify.com/s/files/1/0317/5176/6151/files/de-flag.jpg?v=1650961579)}@media only screen and (max-width: 500px){.langbanner {min-width: 90%; padding: 50px 25px;} .langbanner button {font-size:18px} .langbanner button:before {width: 35px; height: 23px;}}</style>";
    $('body').append(style);
    $('body').append(banner);
    setTimeout(function(){
      $('button.change').on('click',function(){
        window.location.href = "https://www.john-crocket.de" + window.location.pathname;
      });
      $('button.stay').on('click',function(){
        $('.langoverlay').fadeOut(300);
        setCookie('languagechoice', 'en', 14);
      });
      $('.langoverlay').fadeIn();
    },6000);
    
    //console.log("[DEV] show banner to DE");
  } else if (!prefDE && l == "de" && x != "de"){
    //var banner = "<div class='langoverlay'><div class='langbanner'><p>You have landed on the German version of our website. If you want to continue on the English version, please click here:</p><button class='change'>To the English Shop</button><button class='stay'>Do not change and close</button></div></div>";
    //var style = "<style>.langoverlay{display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.5);z-index:100}.langbanner{width:34%;background:#fff;top:50%;position:absolute;left:50%;transform:translate(-50%,-50%);padding:50px 30px;text-align:center;border-radius:5px;box-shadow:0 0 15px #62626262}.langbanner p{text-align:center}.langbanner button{font-size:22px;font-weight:inherit;width:100%;padding:5px 20px;border-radius:3px}.langbanner button.change{color:#fff;background:#4ba733;margin-bottom: 1rem;margin-top: 1rem}</style>";
    var banner = "<div class='langoverlay'><div class='langbanner'><button class='change en'>Continue in English</button><button class='stay de'>Weiter auf Deutsch</button></div></div>";
    var style = "<style>.langoverlay{display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.5);z-index:100}.langbanner{width:34%;background:#fff;top:50%;position:absolute;left:50%;transform:translate(-50%,-50%);padding:70px 50px;text-align:center;border-radius:5px;box-shadow:0 0 15px #62626262}.langbanner button{font-size:22px;font-weight:inherit;width:100%;padding:5px 20px;border-radius:3px;color: #fff;background: #a1a1a1;position: relative}.langbanner button.change{background:#4ba733;margin-bottom: 1rem}.langbanner button:before{content:'';width: 46px; height: 30px;position:absolute;left:7px;top: 7px;background-size: contain; background-repeat:no-repeat; background-image: url(https://cdn.shopify.com/s/files/1/0317/5176/6151/files/gb-flag.jpg?v=1650961579)}.langbanner button.de:before {background-image:url(https://cdn.shopify.com/s/files/1/0317/5176/6151/files/de-flag.jpg?v=1650961579)}</style>";
    $('body').append(style);
    $('body').append(banner);
    setTimeout(function(){
      $('button.change').on('click',function(){
        window.location.href = "https://www.john-crocket.com" + window.location.pathname;
      });
      $('button.stay').on('click',function(){
        $('.langoverlay').fadeOut(300);
        setCookie('languagechoice', 'de', 14);
      });
      $('.langoverlay').fadeIn();
    },6000);
    //console.log("[DEV] show banner to EN");
  }
//console.log("[DEV] " + userLang + " " + prefDE, window.location.pathname);
}
langDetection();

function langSwitches(){
  var l = $('html').attr('lang'),
      d = "https://www.john-crocket.de",
      e = "https://www.john-crocket.com";
  if(l == "de"){
    $('[data-de]').each(function(){
      var inner = $(this).html(),
          newinner = "<b>" + inner +"</b>";    
      $(this).html(newinner);
    })
    $('[data-en]').each(function(){
      var inner = $(this).html(),
          newinner = "<a href='" + e + "'>" + inner +"</b>";    
      $(this).html(newinner);      
    })
  } else if (l == "en"){
    $('[data-en]').each(function(){
      var inner = $(this).html(),
          newinner = "<b>" + inner +"</b>";    
      $(this).html(newinner);      
    })
    $('[data-de]').each(function(){
      var inner = $(this).html(),
          newinner = "<a href='" + d + "'>" + inner +"</b>";    
      $(this).html(newinner);      
    })
  }
  
}

function sesamibooking(){
  if($('.sesami__button').length){
    $('.price-info-wrapper').hide();
  }
  $('.sesami__button').addClass('disabled btn btn--full add-to-cart').css('line-height', '1.42').css('pointer-events', 'none').prop('disabled', true);

  $('sesami-button').on('click', function(e){
    console.log('eh');
    if($('.sesami__button').hasClass('disabled')){
       e.preventDefault();
      console.log('nope');
      $('.line-item-property__field.required').addClass('error');
    }
  });
  //$(document).on('click', function(e){console.log(e.target)})
  $('.line-item-property__field.required input').on('input', function(){
    $('.sesami__button').removeClass('disabled').prop('disabled', false).css('pointer-events', 'all');
  })
  //var btns = $('.sesami__buttonWrapper');
  //btns.each(function(){
    //$('.price-info-wrapper').hide();
    //var parent = $(this).parent();
    //var DateInput = parent.find('input[id^=sesami-date-]');
    //var submit = parent.find('[type=submit]');
    //parent.find('.sesami_placeholder').remove();
    //var TimeInput = parent.find('input[id^=sesami-time-]');
    //console.log('sesami detected', parent, DateInput)
    //DateInput.change(function(){
    //  console.log("changed Date")
    //  submit.click();
    //})
    //TimeInput.change(function(){
    //  console.log("changed Time")
    //})
  //})
}

function videomute(){
  if($('button.unmute').length){ 
    $('button.unmute').on('click', function(){
      var id = $(this).attr('data-videoid');
      if($(this).hasClass('m')){
        $(this).removeClass('m');
        $('video#'+ id).prop('muted', false);
      } else {
        $(this).addClass('m');
        $('video#'+ id).prop('muted', true);
      }
    })
  }
}

function initVideo(){
  var video = '.videocontainer-mp4 video';
  if($(video).length){
    var vtop = $(video).offset().top,
    vbottom = vtop + $(video).height();
    $(video).on('play', function(){$(this).addClass('playing')})
    $(video).on('pause', function(){
      if($(this).hasClass('scrollpause')){
        return;
      }
      $(this).removeClass('playing')
    })
    $(window).on('scroll.custom', function(){
      handleVideoOnScroll(video,vtop,vbottom)
    })
  }
}
function handleVideoOnScroll(vid, top, bottom){
  var video = $(vid);

  if(($(window).scrollTop() + $(window).height()) <= top || $(window).scrollTop() >= bottom){
    if(video.hasClass('playing')){
      video.addClass('scrollpause').trigger('pause');
    }
  } else {
    if(video.hasClass('playing')){
      video.trigger('play').removeClass('scrollpause');
    }
  }
}
initVideo();

theme.customerTemplates = (function() {
  
    /* Show/Hide recover password form */
    function toggleRecoverPasswordForm() {
      if ($('#RecoverPasswordForm').hasClass('hide')){
        $('#RecoverPasswordForm').removeClass('hide');
      	$('#CustomerLoginForm').addClass('hide');
      } else {
      	$('#RecoverPasswordForm').addClass('hide');
      	$('#CustomerLoginForm').removeClass('hide');
      }
    }
  
    function showRecoverPasswordForm(){
      $('#RecoverPasswordForm').removeClass('hide');
      $('#CustomerLoginForm').addClass('hide');
    }
    function hideRecoverPasswordForm(){
      $('#RecoverPasswordForm').addClass('hide');
      $('#CustomerLoginForm').removeClass('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
      });
  
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
      });    
    }
  
    /*Show reset password success message */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  
    
  
    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        showRecoverPasswordForm();
      }
    }
  
    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
      }
    };
  })();


function checkMail(email) {
  return email.match(/^.+@.+\..+$/) !== null;
} 

function validate(){
  $('form.cr_form').submit(function(event) {
    email = $(this).find('input[name="email"]').val();
    check = $(this).find('input[type="checkbox"]');
    if (checkMail(email) && check.is(':checked')) {
      $(event.target).find('div.error-email').fadeOut(400);
      $(event.target).find('div.error-check').fadeOut(400);
    } else {
      if(!checkMail(email)){
        $(this).find('div.error-email').not('.contact').fadeIn(1000);
        $(event.target).find('div.error-check').fadeOut(400);
        event.preventDefault();
      } else if (!check.is(':checked')){
        $(this).find('div.error-check').not('.contact').fadeIn(1000);
        $(event.target).find('div.error-email').fadeOut(400);
        event.preventDefault();
      }
    }
  });
  $('form.cr_form input[name="email"]').on('input', function(){
    email = $(this).val();
    if(checkMail(email)){
      $('form.cr_form .privacy-check').slideDown();
    } else {
      $('form.cr_form .privacy-check').slideUp();
    }
  });
}

function validateContact(){
  $('form#contact_form button[type="submit"]').on('click', function(event) {
    console.log('submit called');
    email = $('input[name="contact[email]"]').val();
    check = $('input[name="contact-datenschutz"]');
    if (checkMail(email) && check.is(':checked')) {
      $('div.error-email.contact').fadeOut(400);
      $('div.error-check.contact').fadeOut(400);
    } else {
      if(!checkMail(email)){
        $('div.error-email.contact').fadeIn(1000);
        $('div.error-check.contact').fadeOut(400);
        event.preventDefault();
      } else if (!check.is(':checked')){
        $('div.error-check.contact').fadeIn(1000);
        $('div.error-email.contact').fadeOut(400);
        event.preventDefault();
      }
    }
  });
  $('form#contact_form input[name="contact[email]"]').on('input', function(){
    email = $(this).val();
    $('.collapsible-content.is-open').css('height','auto');
    if(checkMail(email)){
      $('form#contact_form .privacy-check').slideDown();
    } else {
      $('form#contact_form .privacy-check').slideUp();
    }
  });
}



//$( "p.collection-text-position" ).replaceWith( $( "#CollectionSection .rte p" ) );
$( "form.product-single__form" ).after( $( "div.collapsibles-wrapper" ) );



  var abmeldesuccessContent = `<div class="newsletter abmeldebestaetigung" style="margin-bottom: 60px;"><div class="container-fluid" style="margin-top: 0;"><div class="row"><div class="col-md-12"><h2 class="upper" style="margin-top: 60px;">John Crocket <span class="underline">Newsletter</span></h2></div></div></div><div class="container-fluid nl-hinweis success" style="margin-bottom: 2%;"><div class="row"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div><div class="col-lg-10 col-md-10 col-sm-10 col-xs-10"><p><span class="font-weight-bold">Schade, aber ok!</span><br> Sie sind nun vom John Crocket Newsletter abgemeldet. Wir würden uns freuen, wenn Sie uns dennoch gewogen bleiben.<br><br> Falls Sie sich noch einmal umentscheiden möchten, können Sie den Newsletter hier jederzeit wieder bestellen:</p></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div></div></div><div class="container-fluid"><div class="row"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div><div class="col-lg-10 col-md-10 col-sm-10 col-xs-10"><script>// <![CDATA[function loadjQuery(e,t){var n=document.createElement("script");n.setAttribute("src",e);n.onload=t;n.onreadystatechange=function(){if(this.readyState=="complete"||this.readyState=="loaded")t()};document.getElementsByTagName("head")[0].appendChild(n)}function main(){var $cr=jQuery.noConflict();var old_src;$cr(document).ready(function(){$cr(".cr_form").submit(function(){$cr(this).find('.clever_form_error').removeClass('clever_form_error');$cr(this).find('.clever_form_note').remove();$cr(this).find(".musthave").find('input, textarea').each(function(){if(jQuery.trim($cr(this).val())==""||($cr(this).is(':checkbox'))||($cr(this).is(':radio'))){if($cr(this).is(':checkbox')||($cr(this).is(':radio'))){if(!$cr(this).parent().find(":checked").is(":checked")){$cr(this).parent().addClass('clever_form_error')}}else{$cr(this).addClass('clever_form_error')}}});if($cr(this).attr("action").search(document.domain)>0&&$cr(".cr_form").attr("action").search("wcs")>0){var cr_email=$cr(this).find('input[name=email]');var unsub=false;if($cr("input['name=cr_subunsubscribe'][value='false']").length){if($cr("input['name=cr_subunsubscribe'][value='false']").is(":checked")){unsub=true}}if(cr_email.val()&&!unsub){$cr.ajax({type:"GET",url:$cr(".cr_form").attr("action").replace("wcs","check_email")+$cr(this).find('input[name=email]').val(),success:function(data){if(data){cr_email.addClass('clever_form_error').before("<div class='clever_form_note cr_font'>"+data+"</div>");return false}},async:false})}var cr_captcha=$cr(this).find('input[name=captcha]');if(cr_captcha.val()){$cr.ajax({type:"GET",url:$cr(".cr_form").attr("action").replace("wcs","check_captcha")+$cr(this).find('input[name=captcha]').val(),success:function(data){if(data){cr_captcha.addClass('clever_form_error').after("<div  class='clever_form_note cr_font'>"+data+"</div>");return false}},async:false})}}if($cr(this).find('.clever_form_error').length){return false}return true});$cr('input[class*="cr_number"]').change(function(){if(isNaN($cr(this).val())){$cr(this).val(1)}if($cr(this).attr("min")){if(($cr(this).val()*1)<($cr(this).attr("min")*1)){$cr(this).val($cr(this).attr("min"))}}if($cr(this).attr("max")){if(($cr(this).val()*1)>($cr(this).attr("max")*1)){$cr(this).val($cr(this).attr("max"))}}});old_src=$cr("div[rel='captcha'] img:not(.captcha2_reload)").attr("src");if($cr("div[rel='captcha'] img:not(.captcha2_reload)").length!=0){captcha_reload()}});function captcha_reload(){var timestamp=new Date().getTime();$cr("div[rel='captcha'] img:not(.captcha2_reload)").attr("src","");$cr("div[rel='captcha'] img:not(.captcha2_reload)").attr("src",old_src+"?t="+timestamp);return false}}if(typeof jQuery==="undefined"){loadjQuery("//ajax.googleapis.com/ajax/libs/jquery/1.4.2/jquery.min.js",main)}else{main()}// ]]></script><form class="layout_form cr_form cr_font newsletter-mainpage" action="https://seu2.cleverreach.com/f/237260-237293/wcs/" method="post" target="_self"><div class="cr_body cr_page cr_font formbox jcform"><div class="non_sortable"></div><div class="editable_content"><div id="5108376" rel="email" class="cr_ipe_item ui-sortable musthave email-input"><div class="error-email" style="display: none;"><span>Bitte geben Sie eine korrekte E-Mail-Adresse ein.</span></div><label for="text5108376" class="itemname">E-Mail*</label> <input id="text5108376" name="email" value="" type="text" placeholder="E-Mail-Adresse" onfocus="this.placeholder=''" onblur="this.placeholder='E-Mail-Adresse'"></div><div id="5108379" rel="button" class="cr_ipe_item ui-sortable submit_container"><button type="submit" class="cr_button submit_container">Anmelden</button></div></div><noscript><a href="http://www.cleverreach.de">www.CleverReach.de</a></noscript></div></form><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div></div></div></div></div>`;
  var anmeldesuccessContent = `<div class="newsletter anmeldebestaetigung" style="margin-bottom: 60px;"><div class="container-fluid" style="margin-top: 0;"><div class="row"><div class="col-md-12"><h2 class="upper" style="margin-top: 60px;">John Crocket <nobr><span class="underline">Newsletter</span></nobr></h2></div></div></div><div class="container-fluid nl-hinweis bestaetigung success" style="margin-bottom: 2%;"><div class="row"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div><div class="col-lg-10 col-md-10 col-sm-10 col-xs-10"><p class="check"><span class="font-weight-bold">Vielen Dank!</span><br> Ihre Anmeldung zum John Crocket Newsletter war erfolgreich! Ab jetzt verpassen Sie keine Angebote oder Neuigkeiten mehr.</p><div class="hemdensale codebanner"><p>Ihr exklusiver Code für <span class="font-weight-bold">40% Rabatt</span> auf Hemden: <br><b style="
">Hemden40</b> <br>Warten Sie nicht zu lange, denn die Aktion endet am 17.6.2021!</p></div></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div></div></div></div>`;
  
  function anmeldeSuccess(){
    $('.main-content').prepend(anmeldesuccessContent);
  }
  function abmeldeSuccess(){
    $('.main-content').prepend(abmeldesuccessContent);
  }
  
  function checkforSuccessHash() {
      var hash = window.location.hash;
 
      if (hash === '#newsletter-angemeldet') {
        anmeldeSuccess();
      } else if(hash === '#newsletter-abgemeldet') {
        abmeldeSuccess();
      }
    }
function nlSuccess(){
  if ($('.shopify-email-marketing-confirmation__container').length){
    var cnt = `<div class="newsletter anmeldebestaetigung" style="margin-bottom: 60px;"><div class="container-fluid" style="margin-top: 0;"><div class="row"><div class="col-md-12"><h2 class="upper" style="margin-top: 60px;">John Crocket <nobr><span class="underline">Newsletter</span></nobr></h2></div></div></div><div class="container-fluid nl-hinweis bestaetigung success" style="margin-bottom: 2%;"><div class="row"><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div><div class="col-lg-10 col-md-10 col-sm-10 col-xs-10"><p class="check"><span class="font-weight-bold">Vielen Dank!</span><br> Ihre Anmeldung zum John Crocket Newsletter war erfolgreich! Ab jetzt verpassen Sie keine Angebote oder Neuigkeiten mehr.</p><div class="hemdensale codebanner"><p>Ihr exklusiver Code für <span class="font-weight-bold">40% Rabatt</span> auf Hemden: <br><b style="
">Hemden40</b></p></div></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div></div></div></div>`;
    $('.main-content').prepend(cnt);
    $('.shopify-email-marketing-confirmation__container').hide();
  }
}

function materialSnips(){
  if ($('.product-material').length){
    $('.material').show();
  }
  if ($('.product-pflege').length){
    $('.pflege').show();
  }
}

function cartQtyChange(){
  if ($( window ).width() > 768) {
    //console.log('width > 768');
    $('.cartqty').each(function(index, el){
      var origin = $('.mobile-cartqty').get(index);
      if ($(el).contents().length == 0){
        $(el).append($(origin).html());
        $(origin).empty();
      }
    });
  }
  
  if ($(window).width() <= 768) {
    $('.mobile-cartqty').each(function(index, el){
      var origin = $('.cartqty').get(index);
      if ($(el).contents().length == 0){
        $(el).append($(origin).html());
        $(origin).empty();
      }
    });
  }
}

function strickFarbToggles(){
  var cashmeretoggle = $('.color-toggle.cashmere'),
      geelongtoggle = $('.color-toggle.geelong'),
      lambswooltoggle = $('.color-toggle.lambswool'),
      cashcolors = $('.grid.cashmere'),
      geecolors = $('.grid.geelong'),
      lambcolors = $('.grid.lambswool');
  cashmeretoggle.on('click', function(evt) {
    evt.preventDefault();
    cashmeretoggle.addClass('active');
    geelongtoggle.removeClass('active');
    lambswooltoggle.removeClass('active');
    geecolors.hide();
    lambcolors.hide();
    cashcolors.show();
  });
  geelongtoggle.on('click', function(evt) {
    evt.preventDefault();
    geelongtoggle.addClass('active');
    cashmeretoggle.removeClass('active');
    lambswooltoggle.removeClass('active');
    cashcolors.hide();
    lambcolors.hide();
    geecolors.show();
  });
  lambswooltoggle.on('click', function(evt) {
    evt.preventDefault();
    lambswooltoggle.addClass('active');
    geelongtoggle.removeClass('active');
    cashmeretoggle.removeClass('active');
    geecolors.hide();
    cashcolors.hide();
    lambcolors.show();
  });
}

function grTabelleToggles(){
  var firsttoggle = $('.color-toggle.one'),
      secondtoggle = $('.color-toggle.two'),
      firsttable = $('.toggle-table-one'),
      secondtable = $('.toggle-table-two');
  firsttoggle.on('click', function(evt){
    evt.preventDefault();
    firsttoggle.addClass('active');
    secondtoggle.removeClass('active');
    firsttable.show();
    secondtable.hide();
  });
  secondtoggle.on('click', function(evt){
    evt.preventDefault();
    firsttoggle.removeClass('active');
    secondtoggle.addClass('active');
    firsttable.hide();
    secondtable.show();
  });
}

/**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
  
      if (!$addressForms.length) {
        if (!$newAddressForm.length){
          return;
        }
      }
  
      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
        $('.newaddresstoggle').toggleClass('hide');
        
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
        $(this).toggleClass('active');
      });
  
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
  
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    }


function accordion(){
  $('[data-trigger]').on('click', function(e){
    e.preventDefault();
    var data = $(this).attr('data-trigger');
    $(this).toggleClass("open");
    //$("[data='" + data + "']").toggle();
    $("[data]").each(function(){
      var newdata = $(this).attr("data");
      if (newdata != data){
        $(this).slideUp();
        $("[data-trigger='" + newdata + "']").removeClass("open");
      } else {
        if($(this).is(":visible")){
          $(this).slideUp();
        } else {
          $(this).slideDown();
        }
      }

   	});
  });
}

function navheight() {
  if($('.site-header .text-center').height() != $('.header-balken').height()){
    $('.header-balken').css('height', $('.site-header .text-center').height() + 'px');
  }
}

function wishtoggle(){
  $('.grid__item.grid-product').mouseover(function(){
    $(this).addClass('hover');
  }).mouseout(function(){
    $(this).removeClass('hover');
  })
}

$('.iWishCount').bind('DOMSubtreeModified', function(){
  if($('.iWishCount').html() == "0"){
    $('.iWishCount').hide();
    $('.wishcnt').hide();
  } else {
    $('.iWishCount').show();
    $('.wishcnt').show();
    }
});

$(document).ready(function() {
  checkforSuccessHash();
  materialSnips();
  strickFarbToggles();
  grTabelleToggles();
  customerAddressForm();
  previewlink();
  accordion();
  nlSuccess();
  langSwitches();
  sesamibooking();
  videomute();
  
    checkCallTime();
  	phonetimesText();  
  $('.phone-indicator').mouseenter(function() {
    $('.phonetimes').show();
  });
  $('.phone-indicator').mouseleave(function() {
    $('.phonetimes').hide();
  });
  
  $('.smooth-scroll').on('click', function(evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top -60},
      500
    );
  });

  $('.scrolldown').on('click', function(evt) {
    window.scrollBy({ top: 800, left: 0, behavior: "smooth" });
  });
  
  theme.customerTemplates.init();
  
  /*$('form.newsletter-mainpage').submit(function(event) {
    email = jQuery(event.target).find('input[name="email"]').val();
    if (checkMail(email)) {
      $(event.target).find('div.error-email').fadeOut(400);
    }
    else {
      $(event.target).find('div.error-email').fadeIn(1000);
      event.preventDefault();
    }
  });*/
  validate();
  validateContact();
  
  $('div.avada-text-child').parent().addClass('avada-text');
  
  $('td[data-label="reloadCart"] span').on('click', function(evt){
    evt.preventDefault();
    $('.cart__update').trigger('click');
  });
  
  
  cartQtyChange();
  navheight();
  $( window ).resize(function(){
    cartQtyChange();
    navheight();
  });
  
  setTimeout(wishtoggle, 3000);
 
});
